import { Select } from "../Select";

export class SelectFactory {
    public static create<TOption>(): new () => Select<TOption> {
        type customSelectCst = new () => Select<TOption>;
        const instance = (Select as any) as customSelectCst;

        return instance;
    }
}
